/**
 * This is the registration data service.
 * @memberOf registration Module
 * @namespace registration Data Service
 */

/**
 * @name registrationDataService
 * @desc Create the data service.
 * @param $q
 * @param $http
 * @param coreService
 * @memberOf registration Module.registration Data Service
 * @ngInject
 */
var registrationDataFactory = function ($q, $http, coreService) {
    // Create the service.
    var service = { };


    return service;
}

export default registrationDataFactory;



// WEBPACK FOOTER //
// ./src/login/registration/registration.data.service.js